<template>
  <div v-if="popoverShow">
    <!-- <b-popover :show.sync="show" :target="id" placement="bottom">
      <template v-slot:title></template>
      <div v-for="(check,i) in options" :key="i">
        <input
          @click="triggerCheckBox(check.value)"
          :value="check.value"
          v-model="selected"
          name="subject"
          checked="checked"
          class="subject-list"
          type="checkbox"
        />
        {{check.text}}
      </div>
    </b-popover>-->
    <b-card :class="sourceFrom == 'summary'?'filter-summarycard':'filter-card'" v-if="popoverShow">
      <v-radio-group class="p-0 m-0 mb-n3" v-model="selected" :mandatory="false">
        <v-radio
          class="p-0 m-0"
          v-for="(radio,i) in partnerFilterType =='Invoice'? invoiceoption:options"
          :key="i"
          :label="radio.text"
          color="#0E5D84"
          :value="radio.value"
        >
          <template v-slot:label>
            <p class="p-0 m-0 pt-1 radiovalue-text">{{radio.text}}</p>
          </template>
        </v-radio>
      </v-radio-group>
      <div
        v-if="selected == 5 && financialYear.length > 0"
        class="finanical-background ml-5 p-0 m-0"
      >
        <v-radio-group class="p-0 m-0 mt-2" v-model="radios" :mandatory="false">
          <v-radio
            class="p-0 m-0 p-1"
            v-for="(radio,i) in financialYear"
            :key="i"
            :label="radio.text"
            @click="getRadioText(radio.text,i)"
            color="#0E5D84"
            :value="radio.value"
          >
            <template v-slot:label>
              <p class="p-0 m-0 pt-1 radiovalue-text">{{radio.text}}</p>
            </template>
          </v-radio>
        </v-radio-group>
      </div>
      <b-button variant="primary" class="filter-button mt-2" @click="triggerFilter()">Apply Filter</b-button>
      <!-- <div v-for="(check,i) in options" :key="i">
        <input
          @click="triggerCheckBox(check.value)"
          :value="check.value"
          v-model="selected"
          :checked="i == 0 ? 1 : 4"
          name="subject"
          class="subject-list float-left"
          type="checkbox"
        />
        <p class="text-left p-0 m-0 mb-2 pl-4">{{check.text}}</p>
      </div>-->
    </b-card>
  </div>
</template>

<script>
import $ from "jquery";
export default {
  components: {},
  props: [
    "popoverShow",
    "id",
    "selected",
    "radios",
    "companycode",
    "categoryCode",
    "financialYear",
    "sourceFrom",
    "partnerFilterType"
  ],
  watch: {
    selected: function(newVal, oldVal) {
      if (newVal) {
        if (this.partnerFilterType == "Invoice") {
          this.invoiceoption.forEach(data => {
            if (data.value == newVal) {
              this.selctedFilterText = data.text;
            }
          });
        } else {
          this.options.forEach(data => {
            if (data.value == newVal) {
              this.selctedFilterText = data.text;
            }
          });
        }
      }
    }
  },
  data() {
    return {
      selected: 1,
      radios: 6,
      selectedValue: "",
      filterValue: "",
      selctedFilterText: "",
      options: [
        { value: 1, text: "All" },
        { value: 2, text: "Previous Month" },
        { value: 3, text: "Previous 3 Month" },
        { value: 4, text: "Previous 6 Month" },
        { value: 5, text: "Fiancial Year" }
      ],
      invoiceoption: [
        { value: 2, text: "Previous Month" },
        { value: 3, text: "Previous 3 Month" },
        { value: 4, text: "Previous 6 Month" },
        { value: 5, text: "Fiancial Year" }
      ],
      financialYear: []
    };
  },
  computed: {
    final: function() {
      return this.additional.concat(this.additional_grouped);
    }
  },
  created() {
    console.log(this.popoverShow);
  },
  methods: {
    getRadioText(text, i) {
      console.log(text, i + 5);
      this.radios = i + 6;
      this.selctedFilterText = text;
    },
    triggerFilter() {
      var selectedValue = {
        text: this.selctedFilterText,
        value: this.selected
      };
      if (this.selected == 5) {
        selectedValue.text = this.financialYear[this.radios - 6].text;
        selectedValue.value = this.radios;
        console.log("Financial selectedValue", selectedValue);
        this.$emit("selectedFilterCategory", selectedValue);
      } else {
        console.log("selectedValue", selectedValue);
        this.$emit("selectedFilterCategory", selectedValue);
      }
    },
    uniqueCheck(e) {
      this.additional_grouped = [];
      if (e.target.checked) {
        this.additional_grouped.push(e.target.value);
      }
    },
    triggerCheckBox(value) {
      $(".subject-list").on("change", function() {
        $(".subject-list")
          .not(this)
          .prop("checked", false);
      });
      this.selectedValue = value;
      console.log(value);
      //   if (this.selected.length > 0) {
      //     this.selected.splice(this.selected.length - 1);
      //     console.log(this.selected);
      //   }
    }
  }
};
</script>
<style scoped>
.radiovalue-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: bold !important;
}
.filter-card {
  position: absolute;
  top: 50px;
  /* left: 0; */
  right: 0;
  width: 40%;
  z-index: 1000;
  display: block;
  box-shadow: 0px 4px 8px #00000033;
  /* position: relative; */
  /* -webkit-transform: translate3d(430px, 309px, 0px); */
  /* transform: translate3d(430px, 309px, 0px); */
  /* top: 16px; */
  /* left: 0px; */
  will-change: transform;
}
.filter-summarycard {
  position: absolute;
  top: 50px;
  width: 100%;
  z-index: 1000;
  display: block;
  box-shadow: 0px 4px 8px #00000033;
}
.subject-list {
  -webkit-appearance: none;
  background-color: #fafafa;
  width: 16px;
  height: 16px;
  border: 1px solid #cacece;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05);
  padding: 9px;
  border-radius: 3px;
  display: inline-block;
  position: relative;
}
.subject-list:active,
.subject-list:checked:active {
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px 1px 3px rgba(0, 0, 0, 0.1);
}

.subject-list:checked {
  background-color: #0c5e9d;
  border: 1px solid #adb8c0;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05),
    inset 0px -15px 10px -12px rgba(0, 0, 0, 0.05),
    inset 15px 10px -12px rgba(255, 255, 255, 0.1);
  color: #fafafa;
}
.subject-list:checked:after {
  content: "\2713";
  font-size: 14px;
  position: absolute;
  top: 0px;
  left: 3px;
  color: #fafafa;
}
.finanical-background {
  background-color: #f5f5f5 !important;
  max-height: 150px !important;
  width: 80%;
  overflow: auto !important;
}
.filter-button {
  outline: none !important;
  width: 80% !important;
  background-color: #0c5e9d !important;
}
</style>